export default "__VITE_ASSET__BiyEAetx__"